import React from 'react';
import { withRouter } from 'react-router-dom';
import NotFound from 'Core/Status/NotFound';
import { askForBlogId } from 'Core/Utils/ContentUtils';
import PaneController from 'RLX/Controllers/PaneController';
import { PaneHeader, SectionTitle } from 'Dashboard/Panes/Common';
import { updateBlog, deleteBlog, renameBlog } from 'RLX/State/Content/ContentActions';


class BlogEditorPane extends PaneController {
  constructor (props) {
    super(props);
    this.onBlogRename = this.onBlogRename.bind(this);
  }

  onBlogRename (blogId) {
    const idIsTaken = (id) => {
      const taken = this.getBlogs().some(blog => blog.id === id);
      if (taken) alert(`The blog id "${id}" is already being used. Please select another id.`);
      return taken;
    }
    return () => {
      if (!confirm(`Are you sure you want to rename the "${blogId}" blog?\nYou will need to re-link the content on pages which reference the old name.`))
        return;
      let newId = blogId;
      do {
        newId = askForBlogId(newId);
      } while (newId != null && idIsTaken(newId));
      if (!newId) return;
      renameBlog(blogId, newId);
      this.props.history.push('/RLX/dash/blogs/' + newId);
    }
  }

  onBlogDelete (blogId) {
    return () => deleteBlog(blogId);
  }

  renderSingle (id) {
    const blog = this.getBlogById(id);
    return !blog
      ? <NotFound homeUrl="/RLX/dash/blogs"/>
      : (
        <div className="Pane EditorPane BlogEditorPane">
          <PaneHeader title={(<span>{blog.id} <small>BLOG</small></span>)}>
            <code className="meta">@{blog.id}</code>
            <button className="positive slim" onClick={this.onBlogRename(blog.id)}>
              Rename Blog
            </button>
            <button className="negative slim" onClick={this.onBlogDelete(blog.id)}>
              Delete Blog
            </button>
          </PaneHeader>
          <SectionTitle icon="book">Posts</SectionTitle>
          <pre><code>{JSON.stringify(blog, null, '  ')}</code></pre>
        </div>
      )
  }
}

export default withRouter(BlogEditorPane);



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/BlogEditor/BlogEditorPane.jsx